$(document).ready(function () {
    // Content section buttons
    if ($('.linkBox-custom').length > 0) {
        $('.linkBox-custom').each(function(){
            var content = '';
            content += "<p>";
            content += $(this).text();
            content += "</p><span></span>";
            $(this).empty();
            $(this).append(content);
		});
    }
});